import { IInstituteLeavesResponse } from '../../apis/institute/institute.interfaces';

export const mockInstituteLeaves: IInstituteLeavesResponse = {
  leaveTypes: [
    { id: 'lt-1', code: 'public', name: 'Public Holiday', description: 'Institute public holidays' },
    { id: 'lt-2', code: 'optional_vacation', name: 'Optional Vacation', description: 'Optional vacation days' },
    { id: 'lt-3', code: 'sick', name: 'Sick Leave', description: 'Medical leave' },
    { id: 'lt-4', code: 'paid', name: 'Paid Leave', description: 'Paid time off' },
  ],
};
